<mat-toolbar class="toolbar">
  <span class="title">Create an account</span>
  <span class="sp"></span>
  <a mat-button routerLink="/login">
    <mat-icon fontSet="material-symbols-outlined">person_add</mat-icon>
    Login
  </a>
</mat-toolbar>

<div class="register-wrap">
  <div class="register-card">
    <h2>Create an account</h2>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="register-form">
      <label
        >Username
        <input type="username" formControlName="username" />
      </label>
      <!-- <label
        >Email
        <input type="email" formControlName="email" />
      </label> -->
      <label
        >Password
        <input type="password" formControlName="password" />
      </label>
      <button type="submit" [disabled]="form.invalid">Sign up</button>
      <p style="color: red" *ngIf="error">{{ error }}</p>
    </form>
    <div class="register-footer">
      Have an account ? <a routerLink="/login">Sign in</a>
    </div>
  </div>
</div>
